var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "14px",
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun_logout_1350646") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Log-Out",
    transform: "translate(-4.000000, -5.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_logout_1350646",
    transform: "translate(4.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.18027283,-0.0261214352 L10.5206091,2.29294309 C11.178871,2.933675 10.1914782,3.89499942 9.53298353,3.25426751 L8.73183091,2.47148422 C8.54944304,2.29327822 8.40152453,2.35183253 8.40152453,2.60234597 L8.40152453,10.247681 C8.40152453,10.6271264 8.08888604,10.9293754 7.70322691,10.9293754 C7.31835253,10.9293754 7.00492929,10.6241704 7.00492929,10.247681 L7.00492929,2.60234597 C7.00492929,2.35287231 6.85701566,2.29324374 6.67455494,2.47148422 L5.87323752,3.25426751 C5.21497564,3.89499942 4.22735004,2.933675 4.88561193,2.29294309 L7.20196214,-0.0229199032 C7.47277971,-0.29368051 7.90980309,-0.294132842 8.18027283,-0.0261214352 Z M3.16401506,3.97720579 C3.48307266,3.66753224 4.00036726,3.66753224 4.31942487,3.97720579 C4.63848247,4.28687935 4.63848247,4.7889594 4.31942487,5.09863296 C2.45065888,6.91243524 2.45065888,9.85318976 4.31942487,11.666992 C6.18819085,13.4807943 9.21805914,13.4807943 11.0868251,11.666992 C12.9555911,9.85318976 12.9555911,6.91243524 11.0868251,5.09863296 C10.7677675,4.7889594 10.7677675,4.28687935 11.0868251,3.97720579 C11.4058827,3.66753224 11.9231773,3.66753224 12.2422349,3.97720579 C14.7491161,6.41035518 14.7491161,10.3552698 12.2422349,12.7884192 C9.73535375,15.2215686 5.67089625,15.2215686 3.16401506,12.7884192 C0.657133867,10.3552698 0.657133867,6.41035518 3.16401506,3.97720579 Z",
    transform: "translate(7.703125, 7.193359) rotate(90.000000) translate(-7.703125, -7.193359) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.92dac6b179ca4186ab054dea2bbaf50a.svg";
export { ForwardRef as ReactComponent };